import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import MainSection from './components/MainSection'
import OperationsSection from './components/OperationsSection'
import ContestSection from './components/ContestSection'
import EvaluateSection from './components/EvaluateSection'

function SubRoutes() {
  return (
    <Switch>
      <Route exact path='/admin'component={() => <Redirect to='/admin/activity' />} />
      <Route exact path='/admin/activity' component={MainSection} />
      <Route path='/admin/activity/new' component={OperationsSection} />
      <Route path='/admin/activity/:id' component={OperationsSection} />
      <Route exact path='/admin/contest' component={ContestSection} />
      <Route path='/admin/contest/:id' component={EvaluateSection} />
    </Switch>
  )
}

export default SubRoutes